import React, { act, useState } from "react";
// import { CustomerInfoBlock, UsersBlock } from "../account-details/blocks";
import { useLocation, useParams } from "react-router-dom";
// import { FarmInfoBlock } from "./blocks";
// import ModalFarmOrSubEnt from "./modals/modal-farm";
import { CustomButton } from "../../components";
// import ModalFarmRemove from "./modals/modal-farm-remove";
// import useFarms from "../../hooks/use-farms";
// import useStrategicAccounts from "../../hooks/use-strategic-accounts";
import ModalUser from "../account-details/modals/modal-user";
// import useUsers from "../../hooks/use-users";
import useFarm from "../../hooks/use-farm";
import { UsersBlock } from "../account-details/blocks";
import useUsers from "../../hooks/use-users";

const ValleyUsers = () => {

  const { valleyUsers, valleyRefetchUsers } = useUsers()

  const [showUserModal, setShowUserModal] = useState(false);
  const [showUserRemoveModal, setShowUserRemoveModal] = useState(false);

  const [activeUser, setActiveUser] = useState(null);


  const handleAddEditUser = (user) => {
    setShowUserModal(true);
    setActiveUser(user);
  };

  const userModalClose = () => {
    setShowUserModal(false);
	  valleyRefetchUsers()
    setShowUserRemoveModal(false);
  }

  const handleRemoveUser = (id) => {
    setShowUserRemoveModal(true);
    // setActiveUser(id);
  };


  const tableUsers =  (
    <UsersBlock
    canCrud={true}
    userConfigType={"Valley"}
   	users={valleyUsers}
      onAddEditUser={handleAddEditUser}
      onRemoveUser={handleRemoveUser}
    />
  );

  const modals = (
    <>
          {showUserModal && (
        <ModalUser
          open={showUserModal}
          onClose={userModalClose}
          user={activeUser||{user_role:"VALMONT_REP"}}     
          account= {null}     
        />
      )}


    </>
  );

  return (
    <>
      {tableUsers}
      {modals}
    </>
  );
};

export default ValleyUsers;
